
import MuiTypography from './MuiTypography';
export default {
  MuiTypography
};
